<template>
  <div class="nav-team-container">
    <div v-for="team in teams" :key="team.name" class="nav-team">
      <b v-b-toggle="'accordion' +  team.name" class="nav-team-header">{{ team.name }}<span class="oi oi-chevron-top"></span></b>
      <b-collapse :id="'accordion' + team.name" class="mt-2">
        <b-card v-if="team.mailbox">
          <ul>
            <router-link :to="{name: 'Inbox', params: { id: team.mailbox.id } }"><li>Inbox <b-badge variant="light" pill> {{ team.mailbox.active_count }} </b-badge></li></router-link>
            <Subfolders :mailbox="team.mailbox" v-if="team.mailbox.subfolders" />
            <router-link :to="{name: 'Board', params: { id: team.mailbox.default_board_id } }"><li>{{team.mailbox.default_board_name}}</li></router-link>
            <a href="#" @click="showNewMessageModal(team.mailbox)"><li>Compose <fa icon="plus-circle" /></li></a>
          </ul>
        </b-card>
      </b-collapse>
    </div>
    <div v-if="filtered" class="filter-toggle">
      <a @click="toggleTeams" class="btn filter-text">{{ toggleBtnText }}</a>
    </div>
  </div>
</template>

<script>
import Subfolders from './Subfolders'
export default {
  name: 'NavTeams',
  props: ['currentUser'],
  components: {
    Subfolders
  },
  data: function () {
    return {
      teams: [],
      allTeams: [],
      filtered: false,
      filteredTeams: [],
      interval: null
    }
  },
  created () {
    this.getTeams()
    var vm = this
    this.interval = setInterval(function () {
      vm.getTeams()
    }, 60000)
    document.addEventListener('visibilitychange', this.teamsIntervals)
  },
  methods: {
    showNewMessageModal (mailbox) {
      this.$root.$emit('composeMessage', mailbox)
    },
    mapOrder (array, order, key) {
      array.sort(function (a, b) {
        var A = a[key]
        var B = b[key]
        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        } else {
          return -1
        }
      })
      return array
    },
    getTeams () {
      var vm = this
      this.$http
        .get('/teams')
        .then(response => {
          this.allTeams = response.data
          if (vm.currentUser.filtered_teams.length > 0) {
            this.filteredTeams = this.allTeams.filter(team => this.currentUser.filtered_teams.includes(team.id))
            this.teams = this.filteredTeams
            this.teams = this.mapOrder(this.teams, this.currentUser.filtered_teams, 'id')
            this.filtered = true
          } else {
            this.teams = vm.allTeams
            this.filtered = false
          }
        })
    },
    toggleTeams () {
      this.teams === this.allTeams ? this.teams = this.filteredTeams : this.teams = this.allTeams
    },
    teamsIntervals () {
      var vm = this
      if (document.hidden === true) {
        clearInterval(this.interval)
      } else {
        this.getTeams()
        this.interval = setInterval(function () {
          vm.getTeams()
          vm.$store.dispatch('loadTeams')
        }, 60000)
      }
    }
  },
  computed: {
    toggleBtnText () {
      return this.teams === this.allTeams ? 'Show preferred mailboxes' : 'Show all mailboxes'
    }
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.teamsIntervals)
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
.filter-toggle a {
  margin-top: 5px;
  color: #fff;
  cursor: pointer;
}
.nav-team-header {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  width: 100%;
  font-size: 20px;
  display: block;
  background-color: #3D829A;
  cursor: pointer;
  text-align: left;
}
.nav-team-header.collapsed {
  background: #57B2CD;
}
.nav-team-header.collapsed:hover {
  background: rgb(84, 166, 193);
}
.nav-team-header .oi-chevron-top {
  transform: translateY(-2px);
  margin-left: 5px;
  font-size: 12px;
}
.nav-team-header.collapsed .oi-chevron-top {
  transform: translateY(-2px) rotateX(180deg);
}
.nav-team .card-body, .nav-team .card {
  background-color: #3D829A;
  padding: 0;
  border-top: none;
}
.nav-team .mt-2 {
  margin-top: 0px !important;
}
.card-body {
  margin-bottom: 10px;
}
.card-body ul {
  text-align: left;
  list-style: none;
  margin-bottom: 0px;
  margin-left: 0px;
  padding-left: 20px;
}
.card-body ul a {
  color: #fff;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/NavTeams.vue